import { useEffect, useState } from 'react';
import { Dialog, IconButton, useMediaQuery } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { Job } from 'lib/types/jobs';
import { ApplyForm } from './ApplyForm';

interface Props {
  job: Job;
  open: boolean;
  onCancel: () => void;
  handleTrackClick: () => void;
}

export const ApplyModal = ({
  job, open, onCancel, handleTrackClick,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [count, setCount] = useState(5);

  const close = (e: any, reason: string) => {
    if (reason) {
      if (reason === 'backdropClick') {
        // disallow backdrop click
        return;
      }
    }

    onCancel();
  };

  useEffect(() => {
    let interval: any;
    const countDown = () => {
      interval = setInterval(() => {
        setCount((prev: number) => {
          if (prev <= 0) {
            clearInterval(interval);
            if (open && job.externalLink) {
              handleTrackClick();
              window.location.href = job.externalLink;
            }
            return 0;
          }
          return (prev - 1);
        });
      }, 1000);
    };

    if (job.externalLink) countDown();

    return () => clearInterval(interval);
  }, [job.externalLink, open]);

  useEffect(() => {
    if (open) setCount(5);
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={close}
      maxWidth="lg"
      fullWidth
      fullScreen={isMobile}
    >
      <div className="p-8">
        <div className="absolute right-2 top-2">
          <IconButton onClick={onCancel}>
            <Close />
          </IconButton>
        </div>
        {
          job.externalLink
            ? (
              <div>
                <div className="mb-4">
                  You are being redirected to an external web page to apply for this job in
                  <span className="font-semibold px-2">{count}</span>
                  seconds.
                  <div>
                    Or, click on the link to be redirected right away:
                    {' '}
                    <a href={job.externalLink} className="underline font-semibold">{job.externalLink}</a>
                  </div>
                </div>
                <div className="text-right"><button type="button" className="btn-primary" onClick={onCancel}>Cancel</button></div>
              </div>
            )
            : <ApplyForm job={job} onCancel={onCancel} />
        }
      </div>
    </Dialog>
  );
};
